// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3e5hJ","colCheckbox":"styles_colCheckbox__1y_A_"};